import Link from "next/link";
import { useEffect } from "react";
import { useConsentStore } from "./consentStore";
import { ConsentDebug } from "./ConsentDebug";
import { ConsentSettings } from "./ConsentSettings";
import { useTrans } from "@/utils/useTrans";
import { Button } from "@/v2-components/ui/button";

export function ConsentBanner() {
  const showBanner = useConsentStore((s) => s.showBanner);
  const showSettings = useConsentStore((s) => s.showSettings);
  const showDeclineButton = useConsentStore((s) => s.showDeclineButton);
  const init = useConsentStore((s) => s.init);
  const openSettings = useConsentStore((s) => s.openSettings);
  const closeSettings = useConsentStore((s) => s.closeSettings);
  const acceptAll = useConsentStore((s) => s.acceptAll);
  const acceptNecessaryOnly = useConsentStore((s) => s.acceptNecessaryOnly);
  const { t } = useTrans(["gnb"]);

  const isInIframe =
    typeof window !== "undefined" && window.self !== window.top;

  useEffect(() => {
    if (!isInIframe) init();
  }, [init, isInIframe]);

  if (isInIframe) return null;

  if (!showBanner && !showSettings) return <ConsentDebug />;

  if (showSettings) {
    return (
      <>
        <ConsentSettings onClose={closeSettings} onSaved={closeSettings} />
        <ConsentDebug />
      </>
    );
  }

  return (
    <>
      <div className="fixed inset-x-0 bottom-0 top-auto z-[100] w-full max-w-full translate-x-0 translate-y-0 !rounded-none bg-transparent !p-0 tablet:inset-x-4 tablet:bottom-4 tablet:max-w-2xl">
        <div className="w-full bg-coolgray-100 px-4 py-8 text-coolgray-10 tablet:rounded-lg tablet:p-8">
          <h2 className="text-lg font-600">{t("Cookies")}</h2>
          <p className="mt-2.5 text-sm">
            {t(
              "This site uses cookies to deliver its service and to analyze traffic. It does not directly identify you but it can be used to provide a more personalized web experience.",
            )}
          </p>
          <div className="mt-2.5 flex flex-wrap items-center gap-4">
            <Link href="/legals">
              <p className="text-sm underline">{t("Cookie Policy")}</p>
            </Link>
            <Link href="/legals/privacy-policy">
              <p className="text-sm underline">{t("Privacy Policy")}</p>
            </Link>
          </div>
          <div className="tablet:flex">
            <div className="mt-8 grid w-full auto-cols-fr grid-flow-row items-center gap-2 tablet:flex">
              <Button
                onClick={openSettings}
                size="sm"
                className="row-start-2 bg-transparent !p-0 underline hover:bg-transparent"
              >
                {t("More Options")}
              </Button>
              <div className="grid grow auto-cols-fr grid-flow-row items-center justify-end gap-2 tablet:flex tablet:flex-wrap">
                {/* opt-in 요구 지역(GDPR/GPC)에만 decline 노출. Nike 패턴.
                    !px-4로 padding 축소 — 프랑스어 등 긴 번역 fit 위해. */}
                {showDeclineButton && (
                  <Button
                    onClick={acceptNecessaryOnly}
                    size="sm"
                    variant="white-outline"
                    className="row-start-2 !px-4"
                  >
                    {t("Accept Only Necessary")}
                  </Button>
                )}
                <Button
                  onClick={acceptAll}
                  size="sm"
                  variant="blue-fill"
                  className="!px-4"
                >
                  {t("Accept All")}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ConsentDebug />
    </>
  );
}
